import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';

const LinkClicksChartHeader = ({
  title,
  description,
  options,
  activeOption,
  onOptionChange
}) => (
  <Row className="align-items-center justify-content-between gy-3 mb-3 mb-md-4">
    <Col xs={12} sm>
      <h2 className="fs-4 fw-bold mb-1">{title}</h2>
      <p className="fs-7 text-gray mb-0">{description}</p>
    </Col>
    {options && (
      <Col xs={12} sm="auto">
        <ButtonGroup className="w-100 w-sm-auto" aria-label={title}>
          {options.map(({ value, label }) => (
            <Button
              key={value}
              type="button"
              variant="outline-lightGray"
              className='py-2'
              style={{ minWidth: '76px' }}
              active={activeOption === value}
              aria-pressed={activeOption === value}
              onClick={() => onOptionChange(value)}
            >
              {label}
            </Button>
          ))}
        </ButtonGroup>
      </Col>
    )}
  </Row>
);

export default LinkClicksChartHeader;
